import { Badge } from "@/components/ui/badge";
import {
  DocumentReviewInstanceStatus,
  DocumentReviewStageInstanceStatus,
  DocumentReviewStageInstanceSummary,
} from "@/lib/api/ach";
import { Clock, CheckCircle, Ban, XCircle, SkipForward } from "lucide-react";

export function getAchInstanceStatusBadge(status: DocumentReviewInstanceStatus) {
  switch (status) {
    case "pending":
      return (
        <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
          <Clock className="mr-1 h-3 w-3" />
          Pending
        </Badge>
      );
    case "in_progress":
      return (
        <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">
          <Clock className="mr-1 h-3 w-3" />
          In Progress
        </Badge>
      );
    case "completed":
      return (
        <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
          <CheckCircle className="mr-1 h-3 w-3" />
          Completed
        </Badge>
      );
    case "cancelled":
      return (
        <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
          <Ban className="mr-1 h-3 w-3" />
          Cancelled
        </Badge>
      );
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
}

export function getAchStageStatusBadge(status: DocumentReviewStageInstanceStatus) {
  switch (status) {
    case "pending":
      return (
        <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
          <Clock className="mr-1 h-3 w-3" />
          Pending
        </Badge>
      );
    case "in_progress":
      return (
        <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">
          <Clock className="mr-1 h-3 w-3" />
          In Progress
        </Badge>
      );
    case "approved":
      return (
        <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
          <CheckCircle className="mr-1 h-3 w-3" />
          Approved
        </Badge>
      );
    case "denied":
      return (
        <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">
          <XCircle className="mr-1 h-3 w-3" />
          Denied
        </Badge>
      );
    case "skipped":
      return (
        <Badge variant="outline" className="bg-gray-50 text-gray-700 border-gray-200">
          <SkipForward className="mr-1 h-3 w-3" />
          Skipped
        </Badge>
      );
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
}

export function getAchCurrentStage(
  stages: DocumentReviewStageInstanceSummary[]
): DocumentReviewStageInstanceSummary | null {
  const sortedStages = [...stages].sort(
    (a, b) => a.ReviewStage.stage_order - b.ReviewStage.stage_order
  );
  return (
    sortedStages.find((stage) => stage.status === "pending" || stage.status === "in_progress") ||
    null
  );
}


